import { render, staticRenderFns } from "./InsuranceTab.vue?vue&type=template&id=6cf7ad70"
import script from "./InsuranceTab.vue?vue&type=script&lang=js"
export * from "./InsuranceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports